import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgIf } from '@angular/common';
import {
  Component,
  Directive,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SurveyTemplate, User } from '../../models';
import { SafeHtmlPipe } from '../../pipes';
import { SurveyPageLogoComponent } from '../survey-page-logo/survey-page-logo.component';

@Directive({
  selector: '[libSurveyIntro]',
  standalone: true,
})
export class SurveyIntroDirective {}

@Component({
  selector: 'lib-survey-intro',
  templateUrl: './survey-intro.component.html',
  styleUrls: ['./survey-intro.component.scss'],
  standalone: true,
  imports: [
    CdkStepperModule,
    NgIf,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    SurveyPageLogoComponent,
    SafeHtmlPipe,
  ],
})
export class SurveyIntroComponent {
  @Input({ required: true }) template!: SurveyTemplate;
  @Input() user: User | null = null;

  acceptPolicy = false;

  @Output() next = new EventEmitter();
}
